import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileServiceService } from './profile-service.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class UserProfileModule { 
  public static forRoot(baseUrl: string): ModuleWithProviders<UserProfileModule> {
    return {
      ngModule: UserProfileModule,
      providers: [
        ProfileServiceService,
          {
              provide: 'baseUrl', // you can also use InjectionToken
              useValue: baseUrl
          }
      ],

  };
  }
}
